import FlexContainer from 'components/atomic/atoms/flex-container';
import { SubtleLink } from 'components/atomic/atoms/subtle-link';
import { Address, type AddressVariant } from 'ui/address';
import { PropertyType, type PropertyTypeVariant } from 'ui/property-type';

export interface AddressBlockProps {
  street: string | null;
  city?: string | null;
  province?: string | null;
  unitNumber?: string | null;
  propertyType: string;
  addressVariant: AddressVariant;
  propertyTypeVariant: PropertyTypeVariant;
  /** Optional link href - renders as anchor with underline on hover */
  href?: string;
  /** Optional click handler (called in addition to navigation if href provided) */
  onClick?: () => void;
}

/**
 * AddressBlock UI component
 * 
 * Combines Address and PropertyType into a single linkable block.
 * When href is provided, both address and property type become part of the link
 * and show underline on hover (matching legacy behavior).
 */
export function AddressBlock({
  street,
  city,
  province,
  unitNumber,
  propertyType,
  addressVariant,
  propertyTypeVariant,
  href,
  onClick,
}: AddressBlockProps) {
  const content = (
    <FlexContainer direction="column" gap={0.5} align="flex-start">
      <Address
        street={street}
        city={city}
        province={province}
        unitNumber={unitNumber}
        variant={addressVariant}
      />
      <PropertyType propertyType={propertyType} variant={propertyTypeVariant} />
    </FlexContainer>
  );

  if (href) {
    return (
      <SubtleLink href={href} onClick={onClick}>
        {content}
      </SubtleLink>
    );
  }

  return content;
}
